/* lm-card-swatches.js — makes the colour swatches on product cards actually work.
   The theme rendered them under the card's full-area link overlay, so every click
   fell through to the link and just opened the product page. This lifts them above
   the overlay, selects the swatch, swaps the card image to that colour and points
   the card link at the matching variant. Custom addition, not part of the original theme. */
(function () {
  function onSwatchClick(e) {
    var lab = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    var input = document.getElementById(lab.htmlFor);
    if (input) input.checked = true;

    var card = lab.closest('.card-wrapper');
    if (!card) return;

    var img = lab.getAttribute('data-variant-image');
    if (img) {
      var media = card.querySelectorAll('.card__media img');
      if (media.length) {
        for (var i = media.length - 1; i >= 1; i--) media[i].remove();
        if (media[0].getAttribute('src') !== img) {
          media[0].removeAttribute('srcset');
          media[0].removeAttribute('sizes');
          media[0].setAttribute('src', img);
        }
      }
    }

    var url = lab.getAttribute('data-variant-url');
    if (url) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.setAttribute('href', url);
      });
    }
  }

  function init() {
    document.querySelectorAll('fieldset[data-lm-swatches]').forEach(function (fs) {
      if (fs.dataset.lmReady) return;
      fs.dataset.lmReady = '1';
      fs.style.position = 'relative';
      fs.style.zIndex = '2';
      fs.querySelectorAll('label.color-swatch').forEach(function (lab) {
        lab.addEventListener('click', onSwatchClick);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
